module.exports = __webpack_public_path__ + "img/application5.ac43d350.png";